import React, {Fragment, useRef, useState} from "react";
import SupporterApi from "../../../apis/SupporterApi";

const SetTicketToasterIdentifier = ({supporterId}) => {

  const [newTicketToasterIdentifier, setNewTicketToasterIdentifier] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);

  const handleClick = (e) => {
    let node = e.target;
    let found = false;

    // ignore clicks on the component itself
    while (node && node.classList) {
      if (node.classList.contains("modal-content")) {
        found = true;
      }

      node = node.parentNode;
    }
    if (!found) {
      handleClose();
      return true;
    }
    return false;
  };

  const handleOpen = () => {
    setNewTicketToasterIdentifier('');
    setIsOpen(true);
  }

  const handleClose = () => {
    setIsOpen(false);
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    SupporterApi.setTicketToasterIdentifierForSupporterProject(supporterId, newTicketToasterIdentifier)
      .then((response) => {
        if (response.status === 200 && response.data.success === true) {
         handleClose();
         window.location.reload();
        } else {
          setErrors(response.data.errors);
        }
      });
  }

  return (
    <Fragment>
      <button className="btn btn-primary" onClick={handleOpen}>
        NFC-Karte hinterlegen
      </button>
      {isOpen && (
        <div className="modal inmodal in" tabIndex="-1" role="dialog" style={{display: 'block'}} ref={node => { this.node = node; }} onClick={handleClick}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <button className="close" onClick={handleClose}>
                  <span>x</span>
                </button>
                <h4 className="modal-title">
                  NFC-Karte hinterlegen
                </h4>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  Bitte lege jetzt die Karte auf den NFC-Reader und schaue, dass die Nummer im folgenden Feld
                  auftaucht.<br/>
                  <input className="form-control" autoFocus={true} type="text" value={newTicketToasterIdentifier}
                         onChange={(e) => setNewTicketToasterIdentifier(e.target.value)}/>
                  <button type="submit" disabled={loading} className="btn btn-warning m-t-lg">
                    Karte speichern
                  </button>
                  {errors && errors.newTicketToasterIdentifier ? (
                    <div className="alert alert-danger m-t-lg">
                      {errors.newTicketToasterIdentifier}
                    </div>
                  ) : null}
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  )
}

export default SetTicketToasterIdentifier;